import PropTypes from "prop-types";
import { useContext } from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { AssetMenu } from "@pages/client/assets/components/asset-menu";
import { ExpandableSidebarStateProvider } from "@context/shared/ExpandableSidebarState";
import { ExpandableSideBar } from "@components/shared/elements/expandable-sidebar";
import { SIDEBAR_KEYS } from "@config/shared/storage-keys";
import { TopNavHeightContext } from "@context/client/TopNavHeight";

const StyledContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "topNavHeight",
})(({ theme, topNavHeight }) => ({
  display: "flex",
  flexDirection: "row",
  overflow: "hidden",
  // Fill the parent, not the viewport: `100vw` ignores the layout container's
  // gutters and overflows the right edge, pushing page padding off-screen.
  width: "100%",
  minHeight: `calc(100vh - ${topNavHeight}px)`,
  backgroundColor: theme.palette.background.paper,
  position: "relative",
  "@media print": {
    display: "block",
    overflow: "visible",
    minHeight: 0,
  },
}));

// to help the content box take up the remaining space
const ContentBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "topNavHeight",
})(({ topNavHeight }) => ({
  flex: 1,
  minWidth: 0,
  overflowX: "auto",
  height: `calc(100vh - ${topNavHeight}px)`,
  // Print: the fixed-height scroll box would clip everything below the fold,
  // so let the content flow onto the following pages.
  "@media print": {
    height: "auto",
    overflow: "visible",
  },
}));

const AssetLayout = (props) => {
  const { children } = props;
  const { topNavHeight } = useContext(TopNavHeightContext);
  return (
    <StyledContainer topNavHeight={topNavHeight}>
      <ExpandableSidebarStateProvider>
        <ExpandableSideBar
          topNavHeight={topNavHeight}
          storageKey={SIDEBAR_KEYS.ASSETS}
          startCollapsed
        >
          <AssetMenu />
        </ExpandableSideBar>
        <ContentBox topNavHeight={topNavHeight}>{children}</ContentBox>
      </ExpandableSidebarStateProvider>
    </StyledContainer>
  );
};

export default AssetLayout;

AssetLayout.propTypes = {
  children: PropTypes.node,
};

StyledContainer.propTypes = {
  theme: PropTypes.shape({
    palette: PropTypes.any,
  }),
};
